import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider";
import { OccasionBanner } from "./OccasionBanner";

export function Layout({ children }: { children: ReactNode }) {
  const { email, signOut, isAdmin } = useAuth();
  return (
    <div className="min-h-full flex flex-col">
      <OccasionBanner />
      <header className="border-b border-neutral-200/70 bg-[#faf8f4]/90 backdrop-blur sticky top-0 z-10">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <Link
            to="/"
            className="flex items-center gap-1.5 sm:gap-2 min-w-0 shrink"
            aria-label="back2life — home"
          >
            <img
              src="/logo/mark_bloom.png"
              alt=""
              aria-hidden
              className="h-9 w-9 sm:h-11 sm:w-11 object-contain shrink-0"
            />
            <img
              src="/logo/wordmark.png"
              alt="back2life"
              className="h-9 sm:h-12 w-auto object-contain shrink-0"
            />
          </Link>
          <nav className="text-sm text-neutral-600 shrink-0">
            {email ? (
              <div className="flex items-center gap-3 sm:gap-4">
                <Link to="/videos" className="hover:text-black transition whitespace-nowrap">My videos</Link>
                {isAdmin && (
                  <Link to="/admin" className="hover:text-black transition whitespace-nowrap font-medium">Admin</Link>
                )}
                <span className="hidden md:inline text-neutral-500 truncate max-w-[200px]">{email}</span>
                <button onClick={signOut} className="hover:text-black transition whitespace-nowrap">Sign out</button>
              </div>
            ) : (
              <div className="flex items-center gap-3 sm:gap-4">
                <Link to="/signin" className="hidden sm:inline hover:text-black transition">Sign in</Link>
                <Link
                  to="/signup"
                  className="px-3 py-1.5 rounded-full bg-black text-white hover:bg-neutral-800 transition whitespace-nowrap text-sm"
                >
                  <span className="sm:hidden">Sign up</span>
                  <span className="hidden sm:inline">Create account</span>
                </Link>
              </div>
            )}
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-neutral-200/70 text-xs text-neutral-500">
        <div className="mx-auto max-w-6xl px-6 py-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
          <span>© {new Date().getFullYear()} back2life.ai</span>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/contact" className="hover:text-black transition">Customer service</Link>
            <Link to="/privacy" className="hover:text-black transition">Privacy</Link>
            <Link to="/terms" className="hover:text-black transition">Terms</Link>
            <span className="hidden md:inline text-neutral-400">Made for the memories that matter.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
